import { SIGN_SUCESS } from "./action-types";

export function signIn(payload: any) {
  return {
    type: SIGN_SUCESS,
    payload,
  };
}

